export const FIELD = {
  NAME: 'name',
  LABEL: 'Group name'
};

export const COMBINATORS = [
  { name: 'AND', value: 'AND', label: 'And' },
  { name: 'OR', value: 'OR', label: 'Or' }
];

export const COMBINATOR = {
  AND: 'AND',
  OR: 'OR'
};

export const OPERATORS = [
  { name: '=', label: 'equals to' },
  { name: '!=', label: 'not equals to' }
];
